<template>
    <div>
        <PageBanner
            title="Admin Dashboard"
            :subtext="bannerSubtext"
            colour="#3c645d"
        />

        <div class="q-px-md q-pt-md">
            <q-tabs
                :model-value="tab"
                align="left"
                active-color="primary"
                indicator-color="primary"
                no-caps
                @update:model-value="setTab"
            >
                <q-tab name="permissions" icon="o_admin_panel_settings" label="Permissions" />
                <q-tab
                    v-if="canManageAssignments"
                    name="assignments"
                    icon="o_groups"
                    label="Assignments"
                />
            </q-tabs>
            <q-separator />
        </div>

        <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="permissions" class="q-pa-none">
                <StaffPermissionsPanel />
            </q-tab-panel>
            <q-tab-panel v-if="canManageAssignments" name="assignments" class="q-pa-none">
                <StaffAssignmentsPanel />
            </q-tab-panel>
        </q-tab-panels>
    </div>
</template>

<script>
import PageBanner from "@/components/ClientComponents/DashboardComponents/PageBanner.vue";
import StaffAssignmentsPanel from "@/components/StaffAdmin/StaffAssignmentsPanel.vue";
import StaffPermissionsPanel from "@/components/StaffAdmin/StaffPermissionsPanel.vue";
import token from "@/services/util/roleHandler";

export default {
    name: "AdminDashboard",
    components: {
        PageBanner,
        StaffAssignmentsPanel,
        StaffPermissionsPanel,
    },

    data() {
        return {
            role: token.getRole(),
            tab: "permissions",
        };
    },

    computed: {
        canManageAssignments() {
            return this.role === "admin" || this.role === "developer";
        },
        bannerSubtext() {
            return this.canManageAssignments
                ? "Manage staff access, activeness, and reporting assignments."
                : "Manage what the people in your team are able to do.";
        },
    },

    created() {
        const requestedTab = this.$route.query.tab;
        if (requestedTab === "assignments" && this.canManageAssignments) {
            this.tab = requestedTab;
        }
    },

    methods: {
        setTab(tab) {
            this.tab = tab;
            this.$router.replace({
                name: "adminDashboard",
                query: tab === "permissions" ? {} : { tab },
            });
        },
    },
};
</script>
